import { Injectable, effect, inject } from '@angular/core';

import { UserPreferencesService } from './user-preferences.service';

const DARK_CLASS = 'dark';
const SEEDED_KEY = 'fiveworx.communication.preferences.themeSeeded';

/**
 * Applies UserPreferencesService.darkMode() to <html class="dark">, which both Tailwind's
 * @custom-variant and PrimeNG's darkModeSelector ('.dark') key off of. Seeds the initial
 * value from the OS's prefers-color-scheme exactly once (first-ever visit), then never
 * again -- once an agent has an explicit stored preference (even "light", chosen to
 * override a dark OS), that preference wins over the OS from then on.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly preferences = inject(UserPreferencesService);

  constructor() {
    this.seedFromSystemPreferenceIfNeeded();

    effect(() => {
      document.documentElement.classList.toggle(DARK_CLASS, this.preferences.darkMode());
    });
  }

  toggle(): void {
    this.preferences.setDarkMode(!this.preferences.darkMode());
  }

  private seedFromSystemPreferenceIfNeeded(): void {
    if (localStorage.getItem(SEEDED_KEY)) {
      return;
    }

    localStorage.setItem(SEEDED_KEY, '1');

    if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
      this.preferences.setDarkMode(true);
    }
  }
}
